import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api.ts';
import type { GridPage } from '../../lib/grid.ts';
import { LevelBadge, ymd, type PublicNotice } from '../../lib/notices.tsx';

/** 로그인 화면 공지 상자 (CR-030): 게시 중인 전체공지 최근 5건(수준·제목·등록일). 없으면 상자 자체를 감춘다. 링크는 사이트(/notices)라 전체 페이지 이동 (CR-031) */
export function LoginNotices() {
  const q = useQuery({ queryKey: ['login-notices'], queryFn: () => api<GridPage<PublicNotice>>('/public/notices/grid?pageSize=5&sort=-createdAt'), staleTime: 60_000, retry: false });
  const rows = q.data?.rows ?? [];
  if (!rows.length) return null;
  return (
    <section className="auth-card-in mt-5 bg-white border border-slate-200" aria-label="공지">
      <div className="flex items-center h-8 px-3 border-b border-slate-200 bg-slate-50 text-[12px]">
        <b className="text-slate-700">공지</b>
        <span className="flex-1" />
        <a href="/notices" className="text-accent-strong hover:underline">전체 보기 →</a>
      </div>
      <ul>
        {rows.map((n) => (
          <li key={n.id} className="flex items-center gap-2 h-8 px-3 border-b border-slate-100 last:border-b-0 text-[12.5px]">
            <LevelBadge level={n.level} />
            <a href={`/notices/${n.id}`} className="flex-1 min-w-0 truncate text-slate-800 hover:text-accent-strong hover:underline">{n.title}</a>
            <span className="flex-none text-[11.5px] text-slate-400 tabular-nums">{ymd(n.createdAt)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
